import website from "./website";

export const apiWebsite = website;
